module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/man@2x_291192.png";